import React, { useState, useEffect } from "react";

import {
  Box,
  Button,
  Typography,
  ListItemText,
  ListItem,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import theme from "./theme";

function View({ socketDeclarator, room }) {
  const classes = theme();
  const [currentMessage, setCurrentMessage] = useState([]);
  const [incrEment, setIncrement] = useState(0);
  const [statusMessage, setStatusMessage] = useState([]);
  const [userOnline, setUserOnline] = useState([]);
  // const [countUser, setCountUser] = useState(null);

  const handleClick = async (message) => {
    if (message !== "") {
      const messageData = {
        room: room,
        name: "declarator",
        message: message,
        time:
          new Date(Date.now()).getHours() +
          ":" +
          new Date(Date.now()).getMinutes(),
      };

      try {
        await socketDeclarator.emit("send_status_message", messageData);
        setStatusMessage(messageData.message);
      } catch (error) {
        console.log("error");
      }
    }
  };

  useEffect(() => {
    // socketDeclarator.on("user-count", (count) => {
    //   console.log("count:",count)
    //   // setCountUser()
    // })
        socketDeclarator.on("receive_status_message", (data) => {
          setStatusMessage(data);
        });
        //return () => socketDeclarator.removeListener('receive_status_message')
        socketDeclarator.on("online_user", (data) => {
       console.log("online_user: ",data)

       setUserOnline((list) => [...list, data]);
         // setUserOnline(data);
          // userOnline.map(x => data.filter(a => a.author == x.author && a.userID == x.userID).length > 0 ? null : data.push(x))
        });

        socketDeclarator.on("receive_bid_amount", (data) => {
          setCurrentMessage((list) => [...list, data]);
          setIncrement(data.bid);
        });

        socketDeclarator.on("disconnect_user", (data) =>{
          setUserOnline(data);
        });
       
        return () => socketDeclarator.removeAllListeners();
  }, [socketDeclarator]);


  return (

    <div>
      <Box
        style={{
          padding: "15px",
          backgroundColor: "#fff",
          borderRadius: "5px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Grid
              container
              style={{
                backgroundColor: "rgb(248 248 248)",
                borderRadius: "2px",
                boxShadow:
                  "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
              }}
            >
              <Grid container item sm={6}>
                <div style={{ float: "left", height: 200, padding: "8px" }}>
                  <Typography  variant="h4">
                    Lot No 85
                  </Typography>
                  <br />
                  <Typography variant="h5">
                    Diamond Bracelet in 18k
                  </Typography>
                  <Typography variant="h5">
                    Yellow Gold
                  </Typography>
                  <Typography
                    component="h4"
                    color="textSecondary"
                    variant="subtitle"
                  >
                    Reserve Price Php 1000
                  </Typography>
                  <Typography
                    component="h4"
                    color="textSecondary"
                    variant="subtitle1"
                  >
                    Absentee Bid Php 2400
                  </Typography>
                </div>
              </Grid>

              <Grid container item sm={6}>
                <div style={{ width: "100%", backgroundColor: "white" }}>
                  <Box align="center" className={classes.img}>
                    <img
                      style={{ width: "200px", height: "200px" }}
                      alt="aswome"
                      src="https://sothebys-md.brightspotcdn.com/dims4/default/b5e5857/2147483647/strip/true/crop/3543x3543+0+0/resize/800x800!/quality/90/?url=http%3A%2F%2Fsothebys-brightspot.s3.amazonaws.com%2Fmedia-desk%2F83%2Fef%2F1969db604e378843793400cf8490%2Fplatinum-3.52ct-ceylon-sapphire-and-diamond-engagement-ring-cfe5.jpg"
                    />
                  </Box>
                </div>
              </Grid>
            </Grid>

            <Box
              style={{
                marginTop: "30px",
                padding: "8px",
              }}
            >
              <Typography align="center" component="h5" variant="h1">
                {statusMessage}
              </Typography>
            </Box>

            <Grid item xs={12} spacing={4}>
              <Box
                display="flex"
                justifyContent="flex-end"
                style={{ marginTop: "20px" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => handleClick("Fair Warning")}
                  className={`${classes.buttonRed} ${classes.ButtonCustom}`}
                >
                  Fair Warning
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => handleClick("Pause")}
                  className={`${classes.pauseButton} ${classes.ButtonCustom}`}
                >
                  Pause
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => handleClick("Revert")}
                  className={`${classes.reverButton} ${classes.ButtonCustom}`}
                >
                  Revert
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} spacing={4}>
              <Box
                display="flex"
                justifyContent="flex-end"
                style={{ marginTop: "20px" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={`${classes.buttonGray} ${classes.ButtonCustom}`}
                >
                  PASS
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={`${classes.buttonGreen} ${classes.ButtonCustom}`}
                >
                  SOLD
                </Button>
              </Box>
            </Grid>

            <TableContainer component={Paper} style={{ marginTop: 50 }}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Image</TableCell>
                    <TableCell align="left">Lot #</TableCell>
                    <TableCell align="left">Title</TableCell>
                    {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                    <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={1}>
                    <TableCell component="th" scope="row">
                      <img
                        style={{ width: "100px", height: "100px" }}
                        alt="aswome"
                        src="https://sothebys-md.brightspotcdn.com/dims4/default/b5e5857/2147483647/strip/true/crop/3543x3543+0+0/resize/800x800!/quality/90/?url=http%3A%2F%2Fsothebys-brightspot.s3.amazonaws.com%2Fmedia-desk%2F83%2Fef%2F1969db604e378843793400cf8490%2Fplatinum-3.52ct-ceylon-sapphire-and-diamond-engagement-ring-cfe5.jpg"
                      />
                    </TableCell>
                    <TableCell align="left">{"81"}</TableCell>
                    <TableCell align="left">
                      {"Diamond Bracelet in 18k Yellow Gold"}
                    </TableCell>
                    {/* <TableCell align="right">{"row.carbs"}</TableCell>
                    <TableCell align="right">{"row.protein"}</TableCell> */}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Right box Start */}
          <Grid item xs={12} sm={6}>
            <Paper style={{ height: "90vh", background: "rgb(248 248 248)" }}>
              <Box style={{ padding: "10px" }}>
                <Box
                  sx={{
                    padding: "30px",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                    boxShadow:
                      "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                  }}
                >
                  <ListItem>
                    <ListItemText>
                      <Typography align="left" variant="h2">
                        Floor Bid
                      </Typography>
                    </ListItemText>

                    <ListItemText>
                      <Typography align="right" variant="h2">
                        PHP {incrEment}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Box>
              </Box>

              <Box style={{ padding: "10px" }}>
                <Box
                  style={{
                    padding: "30px",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                    boxShadow:
                      "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                    textAlign: "center",
                  }}
                >
                  {/* Internet Bid  */}
                  <Typography variant="h1" color="textSecondary">
                    {" "}
                    INTERNET BID
                  </Typography>
                </Box>
              </Box>

              <Box
                display="flex"
                style={{ paddingTop: "15px", padding: "30px" }}
              >
                <Grid direction="row" container spacing={1}>
                  <Grid item sm={6}>
                    <Typography variant="h3">ASK:</Typography>
                  </Grid>
                  <Grid container justifyContent="flex-end" item sm={6}>
                    <Typography variant="h3">300,000</Typography>
                  </Grid>
                  <Grid container item sm={6}>
                    <Typography variant="h3">INCREMENT:</Typography>
                  </Grid>
                  <Grid container justifyContent="flex-end" item sm={6}>
                    <Typography variant="h3">{"20,000"}</Typography>
                  </Grid>
                  <Grid container item sm={6}>
                    <Typography variant="h3">CURRENT BID:</Typography>
                  </Grid>
                  <Grid container justifyContent="flex-end" item sm={6}>
                    <Typography variant="h3">{incrEment}</Typography>
                  </Grid>

                  <Grid container item>
                    <Typography variant="h6">HIGH BIDER:</Typography>
                  </Grid>

                  {/* <Grid container item sm={6}>
                    <Typography variant="h6">OTHERS PARTICIPANTS:</Typography>
                  </Grid> */}
                </Grid>
              </Box>

              <Box style={{ padding: 10 }}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TableContainer
                      component={Paper}
                      className={classes.container}
                    >
                      <Table stickyHeader aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left" colSpan={3}>
                              Bid History
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              style={{ lineHeight: "0.5rem" }}
                              align="left"
                            >
                              Username
                            </TableCell>
                            <TableCell
                              style={{ lineHeight: "0.5rem" }}
                              align="right"
                            >
                              Bid
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        <TableRow  >
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                                style={{ lineHeight: "0.5rem" }}
                              >
                                user 2
                              </TableCell>
                              <TableCell
                                style={{ lineHeight: "0.5rem" }}
                                align="right"
                              >
                                20,000
                              </TableCell>
                            </TableRow>
                            <TableRow  >
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                                style={{ lineHeight: "0.5rem" }}
                              >
                                user 3
                              </TableCell>
                              <TableCell
                                style={{ lineHeight: "0.5rem" }}
                                align="right"
                              >
                                30,000
                              </TableCell>
                            </TableRow>
                            <TableRow  >
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                                style={{ lineHeight: "0.5rem" }}
                              >
                                user 1
                              </TableCell>
                              <TableCell
                                style={{ lineHeight: "0.5rem" }}
                                align="right"
                              >
                                40,000
                              </TableCell>
                            </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={6}>
                    <TableContainer
                      component={Paper}
                      className={classes.container}
                    >
                      <Table stickyHeader aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">PARTICIPANTS</TableCell>
                            <TableCell align="right" style={{color: 'green',}}><Typography variant="h3" >3</Typography></TableCell>
                   </TableRow>
                   </TableHead>
                        <TableBody>
                    
                            <TableRow >
                          
                              <TableCell
                                style={{ lineHeight: "0.5rem" }}
                                align="left"
                                colSpan="2"
                              >
                                {'user 1'}
                              </TableCell>
                            
                            </TableRow>
                            <TableRow >
                          
                          <TableCell
                            style={{ lineHeight: "0.5rem" }}
                            align="left"
                            colSpan="2"
                          >
                            {'user 2'}
                          </TableCell>
                        
                        </TableRow>
                        <TableRow >
                          
                          <TableCell
                            style={{ lineHeight: "0.5rem" }}
                            align="left"
                            colSpan="2"
                          >
                            {'user 3'}
                          </TableCell>
                        
                        </TableRow>
                   
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>
          {/* Right box End */}
        </Grid>
      </Box>
    </div>
  );
}

export default View;
